import React from 'react';
import times from 'lodash/times';
import {
  NetWorthTableGroupHeader,
  NetWorthTableHeader,
  NetWorthTableLabelCell,
  NetWorthTableRow,
  NetWorthTableValueCell,
  StyledNetWorthTable,
} from './NetWorthTableStyles';

interface Props {}

export const NetWorthTableEmpty: React.FC<Props> = () => {
  return (
    <StyledNetWorthTable>
      <NetWorthTableHeader>
        <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Description</NetWorthTableLabelCell>
        <NetWorthTableValueCell style={{ fontWeight: 600 }}>Total</NetWorthTableValueCell>
      </NetWorthTableHeader>
      {times(4).map(key => (
        <React.Fragment key={key}>
          <NetWorthTableGroupHeader color="#333">
            <span style={{ visibility: 'hidden' }}>Phantom</span>
          </NetWorthTableGroupHeader>
          <NetWorthTableRow>
            <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Total</NetWorthTableLabelCell>
          </NetWorthTableRow>
        </React.Fragment>
      ))}
    </StyledNetWorthTable>
  );
};
